import { render } from "./NewAskForQuotes.vue?vue&type=template&id=dadf1912"
import script from "./NewAskForQuotes.vue?vue&type=script&lang=js"
export * from "./NewAskForQuotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__